export const languages = ["English","French", "Hebrew"];